import React from 'react';

import { DeletePII } from '../DeleteCustomerPII';

import { Lead } from '@/pages/types';

export const AccountAndContactInfo = ({ lead }: { lead: Lead }) => {
  const showDeletePiiOption = !lead.email.includes('DELETED');

  return (
    <div className="flex-col">
      <h2 className="mb-1 flex items-center">
        <b className="inline-block">Lead Details</b>
      </h2>
      <div className="bg-white border rounded-lg p-4 shadow-md h-[260px] overflow-y-scroll">
        <div className="mb-2">
          <strong>Customer ID:</strong> {lead.account_id || '--'}
        </div>
        <div className="mb-2 flex items-center">
          <strong>Email address:</strong>{' '}
          <div className="flex items-center ml-1">
            <span>{lead.email}</span>
            {showDeletePiiOption && <DeletePII email={lead.email} is_lead id={lead.id} />}
          </div>
        </div>
        <div className="mb-2">
          <strong>Account status:</strong> {lead.account_status || '--'}
        </div>
        <div className="mb-2">
          <strong>Gladly ID:</strong> {lead.account_gladly_customer_id || '--'}
        </div>
        <div className="mb-2">
          <strong>Pricing Model:</strong> {lead.pricing_model?.name}
        </div>
      </div>
    </div>
  );
};
